import { Navigate, Route, Routes } from 'react-router-dom';
import { KnowledgeBaseLayout } from '@/pages/admin/knowledge-base/KnowledgeBaseLayout';
import { LibraryPage } from '@/pages/admin/knowledge-base/LibraryPage';
import { DocumentViewer } from '@/pages/admin/knowledge-base/DocumentViewer';
import { DocumentEditor } from '@/pages/admin/knowledge-base/DocumentEditor';
import { ChaptersListPage } from '@/pages/admin/knowledge-base/ChaptersListPage';
import { ChapterEditorPage } from '@/pages/admin/knowledge-base/ChapterEditorPage';
import { AssignmentsPage } from '@/pages/admin/knowledge-base/AssignmentsPage';
import { QuizzesListPage } from '@/pages/admin/knowledge-base/QuizzesListPage';
import { QuizBuilderPage } from '@/pages/admin/knowledge-base/QuizBuilderPage';
import { AnnouncementsPage } from '@/pages/admin/knowledge-base/AnnouncementsPage';
import { AuditPage } from '@/pages/admin/knowledge-base/AuditPage';
import { SourcesPage } from '@/pages/admin/knowledge-base/SourcesPage';

export function KnowledgeBaseAdmin() {
  return (
    <Routes>
      <Route element={<KnowledgeBaseLayout />}>
        <Route index element={<Navigate to="library" replace />} />
        <Route path="library" element={<LibraryPage />} />
        <Route path="library/new" element={<DocumentEditor />} />
        <Route path="library/:id" element={<DocumentViewer />} />
        <Route path="library/:id/edit" element={<DocumentEditor />} />

        <Route path="chapters" element={<ChaptersListPage />} />
        <Route path="chapters/:id" element={<ChapterEditorPage />} />

        <Route path="assignments" element={<AssignmentsPage />} />

        <Route path="quizzes" element={<QuizzesListPage />} />
        <Route path="quizzes/:id" element={<QuizBuilderPage />} />

        <Route path="announcements" element={<AnnouncementsPage />} />

        <Route path="audit" element={<AuditPage />} />

        <Route path="sources" element={<SourcesPage />} />

        <Route path="*" element={<Navigate to="library" replace />} />
      </Route>
    </Routes>
  );
}
